<template>
  <v-container>
    <v-btn color="primary" @click="coffeeSizeAdd()">Yeni Kahve Boyutu Ekle</v-btn>
    <br />
    <br />

    <v-card>
      <v-card-title>
        Kahve Boyutları
        <v-spacer></v-spacer>
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          label="Ara"
          single-line
          hide-details
        ></v-text-field>
      </v-card-title>
      <v-data-table
        :headers="headers"
        :items="allCoffeeSizeList"
        :footer-props="{
    'items-per-page-options': [10,25,50,100]
  }"
        :items-per-page="10"
        :search="search"
      >
        <template v-slot:item.active="{ item }">
          <v-checkbox v-model="item.active" @change="coffeeSizeStatusChange(item)"></v-checkbox>
        </template>
        <template v-slot:item.actions="{ item }">
          <v-icon small class="mr-2" @click="coffeeSizeEdit(item)">mdi-pencil</v-icon>
        </template>
      </v-data-table>
    </v-card>
  </v-container>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

export default {
  name: "CoffeeSizes",
    data: () => ({
    search: "",
    headers: [
      { text: "Kahve Boutu", value: "coffeeSize" },
      { text: "Aktif/Pasif", value: "active" },
      { text: "Detay", value: "actions", sortable: false }
    ]
  }),
  computed: mapGetters(["allCoffeeSizeList"]),
    created() {
    this.getCoffeeSizes();
  },
  methods: {
    ...mapActions(["getCoffeeSizes","updateCoffeeSizeStatus"]),
    //coffeeSizeStatusChange
    coffeeSizeStatusChange(coffeeSize) {
      console.log("coffeeSize", coffeeSize);
      this.updateCoffeeSizeStatus(coffeeSize).then(response=>{
         console.log("response",response);
         if(response.processStatus=="Success") {
           alert("Güncelleme işlemi başarılıdır");
         }
         else {
           alert("Bir hata oluştu");
         }
       }).catch(err=>{
           alert(err);
       })

    },
    //coffeeSSizeAdd
    coffeeSizeAdd() {
      this.$router.push("coffeeSize");
    },
    //Coffee Size Detail
    coffeeSizeEdit(item) {
      this.$router.push(`/dashboard/productCategories/coffeeSize/${item.id}`);
    }
  }
};
</script>

<style>
</style>